<template>
  <div class="invoice-list">
    <CommonList
      ref="commonList"
      bottomBtnText="分享"
      :showTop="false"
      :cellOperabled="false"
      :showBottom="true"
      @onSubmit="onSubmit"
    />
  </div>
</template>

<script>
import CommonList from "@components/CommonList.vue";

export default {
  name: "share",

  components: {
    CommonList,
  },

  methods: {
    onSubmit(data) {
      let files = [];
      files = data.map((item) => {
        return {
          id: item.id,
          fileName: item.file.fileName + "." + item.file.extension,
        };
      });
      let url =
        "/pages/options/index?optionType=share&files=" + JSON.stringify(files);
      this.$hrefTo(url);
    },
  },
};
</script>

<style lang="less" scoped></style>
